export default {
  setService(state, service) {
    state.service = service
  },
  setServices(state, services) {
    state.services = services
  },
  setServiceErrors(state, serviceErrors) {
    state.serviceErrors = serviceErrors
  },
  setServiceField(state, { key, value }) {
    if (state.service) {
      state.service = {
        ...state.service,
        [key]: value,
      }
    }
  },
  setServiceErrorsField(state, obj) {
    if (state.serviceErrors) {
      state.serviceErrors[obj.key] = obj.value
    }
  },
  setServiceFilters(state, serviceFilters) {
    state.serviceFilters = serviceFilters
  },
  setServiceForm(state, serviceForm) {
    state.serviceForm = serviceForm
  },
  changeService(state, payload) {
    for (let i = 0; i < state.services.length; i++) {
      if (state.services[i].id === payload.key) {
        state.services.splice(i, 1, payload.value)
        break
      }
    }
  },
  unshiftServices(state, service) {
    state.services.unshift(service)
  },
  deleteService(state, id) {
    for (let i = 0; i < state.services.length; i++) {
      if (state.services[i].id === id) {
        state.services.splice(i, 1)
        break
      }
    }
  },
  setServicePriceActual(state, priceActual) {
    if (state.service.price_actual) {
      state.service.price_actual.price = priceActual
    } else {
      state.service.price_actual = {
        price: priceActual,
      }
    }
  },
  setServicePriceIntervalsAdded(state, payload) {
    state.servicePriceIntervalsAdded = payload
  },
  setServicePriceIntervalsRemoved(state, payload) {
    state.servicePriceIntervalsRemoved = payload
  },
  setServicePriceIntervalsAddedMarkedForRemoval(state, payload) {
    state.servicePriceIntervalsAddedMarkedForRemoval = payload
  },
}
